import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import backRed from "../../assets/svg/back-rose-icon.svg";
import AddNew from "../../components/Common/AddNew";
import Breadcrumbs from "../../components/Common/Breadcrumbs/Breadcrumbs";

const AddNewServiceCategory = () => {
  const [serviceList, setServiceList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    list_api_call();
  }, []);

  const list_api_call = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}services/list`)
      .then((response) => {
        setServiceList(response?.data);
      });
  };
  const pathName = useLocation();

  const servicesBreadcrumbs = useMemo(() => {
    return serviceList
      ?.filter((data) => data?.slug_url === pathName.pathname.split("/")[2])
      .map((val) => val);
  }, [serviceList, pathName.pathname]);

  return (
    <>
      <div onClick={() => navigate(-1)} className="rose back-button">
        <img src={backRed} alt="" />
        <span className="rose-back">Back</span>
      </div>
      <div className="mt-4">
        <Breadcrumbs
          breadcrumbText="Web Bookings, Consultations & Appointments"
          breadcrumbLink="/web-bookings/home-healthcare-bookings"
          nestedText={servicesBreadcrumbs[0]?.name}
          nestedLink={`/web-bookings/${servicesBreadcrumbs[0]?.slug_url}`}
          nestedText2="Add New Service Category"
          nestedLink2="#"
        />
        <AddNew
          text="Service Category"
          registerContent="service_category"
          serviceSlug={servicesBreadcrumbs[0]?.slug_url}
          sucessNavigate={`/web-bookings/${
            pathName.pathname.split("/")[2]
          }/view-service-categories`}
        />
      </div>
    </>
  );
};

export default AddNewServiceCategory;
